import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { ProfilePage } from "@/features/auth/routes/Profile";

export const Route = createLazyFileRoute("/_auth/_app/auth/profile")({
  component: memo(ProfilePage),
});
